var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPanama(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h15v12H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#c92d25",
    d: "M30 12H15V0h15z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#081d53",
    d: "M0 24V12h15v12z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30 24H15V12h15z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#081d53",
    d: "M7.81 2.67 7 5.21H4.3L6.48 6.8l-.83 2.54L7.8 7.76l2.17 1.57-.83-2.54L11.3 5.2H8.64z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#c92d25",
    d: "m21.94 13.98-.83 2.55h-2.67l2.16 1.57-.83 2.54 2.17-1.57 2.16 1.57-.83-2.54 2.17-1.57h-2.68z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanama);
export default __webpack_public_path__ + "static/media/panama.33a44ca5bee56f708337e45235eb737f.svg";
export { ForwardRef as ReactComponent };